import { LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { useTranslation } from "react-i18next";
import { DatePicker, DateTimePicker } from '@mui/x-date-pickers';
import dayjs from 'dayjs';
import 'dayjs/locale/he';

const CrmDateTime = ({
  name,
  label,
  value,
  onChange,
  type = 'date',// 'date' | 'datetime'
  required,
  disabled = false,
  readOnly = false,
}) => {
  const handleChange = newValue =>
    onChange({ target: { name, value: newValue, type } });
    const [t] = useTranslation('crm')

  const commonProps = {
    label,
    value: value ? dayjs(value) : null,
    onChange: handleChange,
    format: type === 'datetime' ? 'DD/MM/YYYY HH:mm' : 'DD/MM/YYYY',
    disabled,
    readOnly,
    slotProps: {
      textField: {
        fullWidth: true,
        size: 'small',
        required,
      },
      actionBar: {
        actions: ['today', 'clear', 'accept'], // Also ,'cancel' can be used.
      },
    },
  };

  return (
    <LocalizationProvider
      dateAdapter={AdapterDayjs}
      adapterLocale="he"
      localeText={{
        okButtonLabel:     t('Accept'),     // OK
        // cancelButtonLabel: t('Cancel'),    // (if you show Cancel)
        clearButtonLabel:  t('Clear'),      // Clear
        todayButtonLabel:  t('Now'),    // Today / Now
      }}
    >
      {type === 'datetime' ? (
        <DateTimePicker {...commonProps} ampm={false} closeOnSelect={false} />
      ) : (
        <DatePicker {...commonProps} />
      )}
    </LocalizationProvider>
  );
};

export default CrmDateTime;
